export default __webpack_public_path__ + "static/media/Prison-3D-Model-02.4018b593.jpg";